export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/404/icon-kw-logo-light-v4-e9651b78bb92e6b8b8c8aabb1d4648f3.svg";